import { useState, useEffect } from 'react';
import repo from 'service/repository';
import { INIT_APP_DONE, UPDATE_BOOTSTRAPS } from 'use-app';
import { PATH } from 'config';
import qs from 'query-string';
import { getAuth, saveAuth } from 'service/local-data-provider';

const useInit = () => {
  const [isPending, setIsPending] = useState(true);

  useEffect(() => {
    setIsPending(false);
  }, []);

  return {
    isPending,
  };
};

const loginAsUser = (success, failure) => {
  return Promise.all([
    repo.fetchUserInfo(),
    repo.fetchLicensePlates(),
    repo.fetchBootstraps(),
    repo.fetchParkingRecord(),
    repo.fetchOrders(1, 100, ['parking']),
    repo.agreeTermsOfTaipeiParkinglotService(),
  ])
    .then(data => {
      const payload = {
        me: data[0],
        licensePlates: data[1],
        bootstraps: data[2],
        parkingRecord: data[3],
        orders: {
          parking: data[4].data,
        },
      };

      success(payload);
    })
    .catch(e => {
      failure(e);
    });
};

const useSplash = async ({ dispatch, history, location }, callback) => {
  const initAppWithoutPayload = () => dispatch({ type: INIT_APP_DONE });

  const waitForSplashAnimationComplete = fn => {
    return new Promise(resolve => {
      resolve(callback());
    }).then(() => {
      setTimeout(() => fn(), 2200);
    });
  };

  await repo.fetchBootstraps().then(payload => {
    dispatch({
      type: UPDATE_BOOTSTRAPS,
      payload,
    });
  });

  if (location.pathname === PATH.SERVICE_INSTRUCTION || location.pathname === PATH.MAPS) {
    return waitForSplashAnimationComplete(initAppWithoutPayload);
  }

  const searchQuery = qs.parse(location.search);

  if (searchQuery.OneTimeToken) {
    await repo
      .fetchOneTimeToken(searchQuery.OneTimeToken)
      .then(value => {
        saveAuth(value);
      })
      .catch(e => {
        console.log(e);
      });
  }

  const success = payload => {
    waitForSplashAnimationComplete(() => {
      dispatch({
        type: INIT_APP_DONE,
        payload: payload,
      });

      if (getAuth().scopes === 'user') {
        if (location.pathname === '/' || location.pathname === '/index.html') {
          history.replace(PATH.MAIN);
        } else {
          history.replace(`${location.pathname}${location.search}${location.hash}`);
        }
      } else {
        history.replace(PATH.USER_WELCOME);
      }
    });
  };

  const failure = () => {
    waitForSplashAnimationComplete(() => {
      initAppWithoutPayload();
      history.replace(PATH.USER_WELCOME);
    });
  };

  if (getAuth()?.accessToken) {
    loginAsUser(success, failure);
  } else {
    waitForSplashAnimationComplete(() => {
      initAppWithoutPayload();
      history.push(PATH.EXPIRED);
    });
  }
};

const methods = {
  useInit,
  useSplash,
  loginAsUser,
};

export default methods;
